import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";

const VisitorAuthContext = createContext(null);

export function VisitorAuthProvider({ children }) {
    const [visitor, setVisitor] = useState(null); // null=checking, false=anon, obj=signed in
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        // CRITICAL: If returning from OAuth callback, skip /me so AuthCallback can
        // exchange the session_id and establish the session first.
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        try {
            const { data } = await http.get("/visitor/auth/me");
            setVisitor(data);
        } catch (e) {
            setVisitor(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const logout = async () => {
        try { await http.post("/visitor/auth/logout"); } catch (_) {}
        setVisitor(false);
    };

    return (
        <VisitorAuthContext.Provider value={{ visitor, setVisitor, loading, refresh, logout }}>
            {children}
        </VisitorAuthContext.Provider>
    );
}

export function useVisitorAuth() {
    const ctx = useContext(VisitorAuthContext);
    if (!ctx) throw new Error("useVisitorAuth must be used within VisitorAuthProvider");
    return ctx;
}
